export default function TrapezeDivider() {
  return (
    <section id="counter" className="counter-outter">
      <div className="container">
        <div className="numbers">
          <img src="/images/trapeze-red.svg" className="trapeze trapeze-d" alt="" />
          <img src="/images/trapeze-red.svg" className="trapeze trapeze-d" alt="" />
          <div className="trapeze-m-outer">
            <img src="/images/trapeze-red.svg" className="trapeze trapeze-m" alt="" />
          </div>
          <img src="/images/trapeze-red.svg" className="trapeze trapeze-d" alt="" />
        </div>
      </div>
    </section>
  );
}
